// extracted by mini-css-extract-plugin
export default {"Sitemap":"SiteMap_Sitemap__rzZ2r"};